import { useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "../../lib/api";
import { KeyRound } from "lucide-react";

export default function AdminChangePassword() {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (next !== confirm) return toast.error("New passwords do not match");
        if (next.length < 6) return toast.error("Password must be at least 6 characters");
        setLoading(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            toast.success("Password updated", { description: "Use your new password on next login." });
            setCurrent(""); setNext(""); setConfirm("");
        } catch (e) {
            toast.error(formatError(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto px-6 py-10">
            <div className="mb-8">
                <div className="label-mini">Admin</div>
                <h1 className="font-serif text-4xl font-semibold">Change password</h1>
                <p className="text-ink/60 mt-2">Keep your Zapperus admin account safe.</p>
            </div>

            <div className="bg-white border border-parchment rounded-2xl p-8 shadow-sm">
                <div className="flex items-center gap-3 mb-6">
                    <div className="h-10 w-10 rounded-full bg-brick/10 text-brick flex items-center justify-center">
                        <KeyRound className="h-5 w-5" />
                    </div>
                    <div className="font-serif text-xl font-semibold">Update credentials</div>
                </div>
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="label-mini">Current password</label>
                        <input data-testid="admin-current-password" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="input-field" />
                    </div>
                    <div>
                        <label className="label-mini">New password</label>
                        <input data-testid="admin-new-password" type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} className="input-field" />
                    </div>
                    <div>
                        <label className="label-mini">Confirm new password</label>
                        <input data-testid="admin-confirm-password" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-field" />
                    </div>
                    <button data-testid="admin-password-submit" type="submit" disabled={loading} className="btn-primary">
                        {loading ? "Updating…" : "Update password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
